import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import 'moment/locale/es';
import { useLocation } from 'react-router-dom';

import { IndicacionDetalleHeader } from './detalle/IndicacionDetalleHeader';
import { IndicacionDetalleProfesionales } from './detalle/IndicacionDetalleProfesionales';
import { IndicacionDetalleIndicacion } from './detalle/IndicacionDetalleIndicacion';
import { IndicacionDetalleIndicacionSolicitada } from './detalle/IndicacionDetalleIndicacionSolicitada';
import { IndicacionDetalleRespMedica } from './detalle/IndicacionDetalleRespMedica';
import { GET_ADMIN_INDICACION_DETALLE } from '../../../data/graphQL/queries/AdminIndicacion/getAdminIndicacionDetalle';
import { GET_ESTADOS_INDICACION_APROBACION } from '../../../data/graphQL/queries/AdminIndicacion/getEstadosIndicacionAprobacion';
import { adaptEstadoSolicitudIndicacionArray } from '../../../adapters/adminIndicacion/estadoSolicitudIndicacionAdapter';

export const AdminIndicacionMedico = ({ indicaciones }) => {

  const { state } = useLocation();
  const { dataRegistro } = state;
  const [dataDetalle, setDataDetalle] = useState({});
  const [estados, setEstados] = useState([]);

  // este detalle se consulta acá porque las secciones de la cabecera y las respuestas del médico y comercial
  // las obtengo en esta consulta. Los demás componentes consultan los datos en su interior.    
  useEffect(() => {
    if (!detalleLoading)
      getDetalle({variables: { idIndicacionAprobacion: dataRegistro?.idIndicacionAprobacion }});
    if (!loadingEstados)
      getEstados({ variables: { filtroMedico: 1 } });
  }, []);

  const [getDetalle, { data: dataDetalleMed, loading: detalleLoading }] = useLazyQuery(GET_ADMIN_INDICACION_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDetalleMed || detalleLoading) return;
    setDataDetalle(dataDetalleMed.adminIndicacionDetalle.valorEsperado);
  }, [dataDetalleMed]);

  const [getEstados, { data: dataEstadosMed, loading: loadingEstados }] = useLazyQuery(GET_ESTADOS_INDICACION_APROBACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEstadosMed || loadingEstados) return;
    setEstados(adaptEstadoSolicitudIndicacionArray(dataEstadosMed));
  }, [dataEstadosMed]);

  return (
    <>
      <IndicacionDetalleHeader data={dataDetalle} esMedico={true} />
      <br />
      <IndicacionDetalleProfesionales indicacion={state.dataRegistro} />
      <br />
        {
          indicaciones?.indicaciones.map((indicacion) => {
          return (
            <>
                <IndicacionDetalleIndicacion indicacion={indicacion} esMedico={true} />
                <br />
            </>);

          })}    
      <IndicacionDetalleIndicacionSolicitada indicacion={indicaciones?.indicacionSolicitada} esMedico={true} />
      <br />
      <IndicacionDetalleRespMedica
        data={dataDetalle}
        setDataDetalle={setDataDetalle}
        estados={estados}
        edit={state.edit} />
      
    </>);
};